export default __webpack_public_path__ + "static/media/earthmaster_sx.a66a0ac5.png";